export const BUCKET_FALLBACK = ["#94a3b8", "#3b82f6", "#f59e0b", "#f97316", "#dc2626", "#7f1d1d"];

export const fmtCr = (n) => {
  if (n == null) return "—";
  const a = Math.abs(n);
  const sign = n < 0 ? "−" : "";
  if (a >= 1e7) return `${sign}₹${(a / 1e7).toFixed(a >= 1e9 ? 0 : 1)} Cr`;
  if (a >= 1e5) return `${sign}₹${(a / 1e5).toFixed(1)} L`;
  return `${sign}₹${Math.round(a).toLocaleString("en-IN")}`;
};

export const fmtDelta = (n) => (n == null ? "—" : `${n > 0 ? "+" : n < 0 ? "−" : ""}${fmtCr(Math.abs(n)).replace("₹", "₹")}`);

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const sinceLabel = (iso) => (iso ? `since ${MONTHS[+iso.slice(5, 7) - 1]} ${iso.slice(0, 4)}` : "");
export const fmtDate = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateShort = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", { day: "2-digit", month: "short" }) : "—");
export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: false }) : "—");

export const bucketColor = (label, buckets) => buckets?.find((b) => b.label === label)?.color || "#94a3b8";

export const ageTone = (u) => (u.aged ? "text-red-700 font-bold" : u.watch ? "text-amber-700 font-semibold" : "text-foreground");


export function downloadRows(filename, headers, rows) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [headers.map(esc).join(","), ...rows.map((r) => r.map(esc).join(","))];
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export const UNIT_EXPORT = {
  headers: ["Chassis", "Branch", "Model", "Variant", "Fuel", "Colour", "Age (days)", "Invoice date", "Arrival", "Total cost", "Bank", "Location", "Status", "In transit"],
  row: (u) => [u.chassis, u.dealer_code, u.model || u.model_raw, u.variant, u.fuel, u.colour, u.age, u.invoice_date, u.arrival_date, u.total_cost, u.bank, u.phys_place, u.status, u.in_transit ? "yes" : ""],
};
